module.exports = __webpack_public_path__ + "static/media/bystrina.1bfee675.png";